module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp12_7042.436eba89.png";